import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "topbar" }
const _hoisted_2 = { class: "nav-links" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = {
  ref: "mobileMenu",
  class: "mobile-menu"
}
const _hoisted_7 = { class: "mobile-menu-list" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navLinks, (link) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          key: link.label,
          to: link.to,
          class: "nav-button"
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: link.iconUrl,
              alt: link.label + ' icon',
              class: "nav-icon"
            }, null, 8, _hoisted_3),
            _createElementVNode("span", null, _toDisplayString(link.label), 1)
          ]),
          _: 2
        }, 1032, ["to"]))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.externalActions, (action) => {
        return (_openBlock(), _createElementBlock("button", {
          key: action.label,
          type: "button",
          class: "nav-button",
          onClick: ($event: any) => (_ctx.newWindow(action.url))
        }, [
          _createElementVNode("img", {
            src: action.iconUrl,
            alt: action.label + ' icon',
            class: "nav-icon"
          }, null, 8, _hoisted_5),
          _createElementVNode("span", null, _toDisplayString(action.label), 1)
        ], 8, _hoisted_4))
      }), 128))
    ]),
    _createElementVNode("details", _hoisted_6, [
      _cache[0] || (_cache[0] = _createElementVNode("summary", {
        class: "mobile-menu-trigger",
        "aria-label": "Open navigation menu"
      }, [
        _createElementVNode("span", {
          class: "hamburger-icon",
          "aria-hidden": "true"
        }, [
          _createElementVNode("span"),
          _createElementVNode("span"),
          _createElementVNode("span")
        ]),
        _createElementVNode("span", { class: "mobile-menu-label" }, "Menu")
      ], -1)),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mobileItems, (item) => {
          return (_openBlock(), _createElementBlock("button", {
            key: item.label,
            type: "button",
            class: "nav-button",
            onClick: ($event: any) => (_ctx.handleMobileSelect(item))
          }, [
            _createElementVNode("img", {
              src: item.iconUrl,
              alt: item.label + ' icon',
              class: "nav-icon"
            }, null, 8, _hoisted_9),
            _createElementVNode("span", null, _toDisplayString(item.label), 1)
          ], 8, _hoisted_8))
        }), 128))
      ])
    ], 512)
  ]))
}